const accessToken = "admin_access_token";
const refreshToken = "admin_refresh_token";
const decentralization = "decentralization";

export function hasStorageJwtToken() {
  return !!localStorage.getItem(accessToken);
}

export function removeStorageJwtToken() {
  localStorage.removeItem(accessToken);
}

export function setStorageJwtToken(token: string) {
  localStorage.setItem(accessToken, token);
}

export function setDecentralization(admin: string) {
  return localStorage.setItem(decentralization, admin);
}

export function removeDecentralization() {
  localStorage.removeItem(decentralization);
}

export function getDecentralization() {
  return localStorage.getItem(decentralization);
}

export function getStorageJwtToken() {
  return localStorage.getItem(accessToken);
}
//

export function hasStorageRefreshToken() {
  return !!localStorage.getItem(refreshToken);
}

export function removeStorageRefreshToken() {
  localStorage.removeItem(refreshToken);
}

export function setStorageRefreshToken(token: string) {
  localStorage.setItem(refreshToken, token);
}

export function getStorageRefreshToken() {
  return localStorage.getItem(refreshToken);
}

//

export function removeStorageRememberMe() {
  localStorage.removeItem("isRemember");
}

export function setStorageRememberMe(isRemember: boolean) {
  localStorage.setItem("isRemember", isRemember.toString());
}

export function getStorageRememberMe() {
  return JSON.parse(localStorage.getItem("isRemember") || "false");
}

export function setStorageCurrentEmail(currentEmail: string) {
  localStorage.setItem("currentEmail", currentEmail);
}

export function getStorageCurrentEmail() {
  return localStorage.getItem("currentEmail") || "";
}

export function removeStorageCurrentEmail() {
  localStorage.removeItem("currentEmail");
}

export function setStorageCurrentCode(currentCode: string) {
  localStorage.setItem("currentCode", currentCode);
}

export function getStorageCurrentCode() {
  return localStorage.getItem("currentCode") || "";
}

export function removeStorageCurrentCode() {
  localStorage.removeItem("currentCode");
}

export function setStorageRegisterThirdParty(isThirdParty: boolean) {
  localStorage.setItem("isThirdParty", isThirdParty.toString());
}

export function getStorageRegisterThirdParty() {
  return JSON.parse(localStorage.getItem("isThirdParty") || "false");
}

export function removeStorageRegisterThirdParty() {
  localStorage.removeItem("isThirdParty");
}

// cookie

export function getCookie(cname: string) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca?.length; i++) {
    let c = ca[i];
    // eslint-disable-next-line eqeqeq
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name?.length, c?.length);
    }
  }
  return "";
}

export function setCookie(cname: string, cvalue: string, exdays = 365) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function removeCookie(cname: string) {
  document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export function createSessionCookie(cname: string, cvalue: string) {
  document.cookie = cname + "=" + cvalue + ";path=/";
}
